export enum SexualOrientationEnum {
    Men = 1,
    Women = 2,
    Both = 3,
}
